import { gql } from "@apollo/client";

export default gql`
  mutation updateRequireAccountApproval($approvalRequired: Boolean!){
    updateRequireAccountApproval(approvalRequired: $approvalRequired){
        success
        data{
            requireAccountApproval
            autoFormalizeInvoices
        }
        code
        message
    }
}
`
